export default __webpack_public_path__ + "static/media/SSP.82bf54c0.jpg";